/* eslint-disable array-callback-return */
import React from "react";
import PropTypes from "prop-types";
import StyledFilterProductType from "./FilterProductTypeFlower.styled";
import FilterTypeCheckboxFlower from "./FilterTypeCheckboxFlower";
import SVGIcon from "../utility/SVGIcon";
import { filterProductTypePT } from "../../config/prop-types";

const FilterProductType = React.memo(props => {
  const {
    className,
    heading,
    productTypes,
    searchAhead ,
    checkFilter,
    checkedList,
    checkedSubList,
    name,
    moreCategories,
    loadMore,
    searchBrands,
    clearSearch,
    searchValue,
    notHeader,
    notShowAll,
    disabled
  } = props;
  return (
    <StyledFilterProductType className={className}>
      <div className="filter-product-type__header">
        {!notHeader && <h3 className="t-aside-heading filter-product-type__heading">{heading}</h3>}
        {/*{*/}
          {/*searchAhead ?*/}
          {/*<button className="t-form-button filter-product-type__add">*/}
            {/*<span className="t-hidden">Add {heading}</span>*/}
            {/*<SVGIcon name="plus" />*/}
          {/*</button>*/}
          {/*:*/}
          {/*<button onClick={clearFilterList} className="t-form-button filter-product-type__clear">Clear All</button>*/}
        {/*}*/}
      </div>
      {
        searchAhead &&
        <li className="input-search">
          <div type="submit" className="t-form-button input-search__icon">
            <SVGIcon name="search" />
          </div>
          <input
              className="t-body-small input-search__input"
              id="searchProducts"
              type="text"
              onChange={searchBrands}
              value={searchValue}
              name="search brands"
          />
          <label htmlFor="searchProducts" className="t-hidden">Search {heading}</label>
          <button type="submit" className="t-form-button input-search__button" onClick={clearSearch}>
            <SVGIcon name="close-small" />
            <span className="t-hidden">clear</span>
          </button>
        </li>
      }
      {productTypes && productTypes.length ? productTypes.map((types, index)=>{
          if( index < moreCategories && !notShowAll){
            return (
                <li className="filter-product-type__type" key={types.name}>
                  <FilterTypeCheckboxFlower
                      disabled={disabled}
                      types={types}
                      checked={checkedList.indexOf(types?.uri_param) !== -1}
                      checkFilter={checkFilter}
                      name={name}
                  />
                  {checkedList.indexOf(types.uri_param.toString()) !== -1 && <ul className="filter-product-type__sub-category">
                    {types?.children?.map((item, i) => {
                      return (
                        <li className="filter-product-type__type" key={i}>
                          <FilterTypeCheckboxFlower
                            disabled={disabled}
                            types={item}
                            checked={checkedSubList && checkedSubList.indexOf(item.uri_param.toString()) !== -1}
                            checkFilter={checkFilter}
                            name="sub_category"
                          />
                        </li>
                      )
                    })}
                  </ul>}
                </li>
            )
          }
          else if(notShowAll){
              return (
                  <li className="filter-product-type__type" key={types.id}>
                    <FilterTypeCheckboxFlower
                        disabled={disabled}
                        types={types}
                        checked={checkedList.indexOf(types?.uri_param) !== -1}
                        checkFilter={checkFilter}
                        name={name}
                    />
                  </li>
              )
          }
      }):''}
      {productTypes  && !notShowAll &&  productTypes.length > 3 &&
      <div className="filter-product-type__show">
        <button className="filter-product-type__show-button t-nav-link t-font-Moderat-Medium" onClick={() => loadMore()}>
          { productTypes.length > moreCategories ? 'Show More' : 'Show Less'}
          <span className="t-hidden">filters</span>
        </button>
      </div>
      }
    </StyledFilterProductType>
  );
  }
);

FilterProductType.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  productTypes: filterProductTypePT,
  searchAhead: PropTypes.bool,
  checkFilter: PropTypes.func.isRequired,
  checkedList: PropTypes.array,
  checkedSubList: PropTypes.array,
  name: PropTypes.string.isRequired,
  moreCategories: PropTypes.number,
  searchBrands: PropTypes.func,
  clearSearch: PropTypes.func,
  searchValue: PropTypes.string,
  notHeader: PropTypes.bool,
  notShowAll: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FilterProductType;
